module.exports = __webpack_public_path__ + "img/icon_menu_evaluaciones.6c77001f.svg";